import breadCrumb from '@/components/breadCrumb.vue'
import aboutTopPic from '@/components/topPicAbout.vue'
import topPicTeaching from '@/components/topPicTeaching.vue'
import topPicCourse from '@/components/topPicCourse.vue'
import topPicCombat from '@/components/topPicCombat.vue'
import topPicStudent from '@/components/topPicStudent.vue'
import topPicJoin from '@/components/topPicJoin.vue'
import topPicResponsibility from '@/components/topPicResponsibility.vue'

export const pageMixin = {
    components: {
        Breadcrumb: breadCrumb,
        aboutTopPic,
        topPicTeaching,
        topPicCourse,
        topPicCombat,
        topPicStudent,
        topPicJoin,
        topPicResponsibility,

    },
    watch: {
        '$store.state.commentId': function (newValue, oldValue) {
            console.log('commentId', newValue)
            this.anchorEvent(newValue)
        },
        '$route': function (to, from) {
            console.log('route', to, from)
            // this.anchorEvent(newValue)
            // this.anchorEvent(this.$store.state.commentId)
        },

    },
    data() {
        return {

        }
    },
    methods: {
        anchorEvent(val) {
            if (val) {
                this.$nextTick(() => {
                    let target = document.querySelector(`#${val}`)
                    if (target) {
                        target.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'center' })
                    }
                })

            }
        },
        toShowMore(path) {
            this.$router.push(path)
        },

        downloadPdf(urlArr, index, loadingObj) {



            // urlArr.forEach((ossFileUrl, indexA) => {
            //     console.log('ossFileUrl', ossFileUrl)
            //  c
            // })


            // urlArr.forEach((ossFileUrl, indexA) => {


            // })

            // n 个异步任务，返回 Promise
            function asyncTask(itemUrl, taskNumber) {
                return new Promise((resolve) => {

                    var ossFileUrl = decodeURIComponent(itemUrl);
                    let fileType = 'jpg';
                    if (ossFileUrl.includes(".pdf")) {
                        fileType = "pdf"
                    }
                    // 使用正则表达式匹配中文字符
                    const chinesePattern = /[\u4e00-\u9fa5]/g; // 此正则表达式匹配所有常见的中文字符，并使用 'g' 标志来匹配所有中文字符
                    const chineseCharacters = ossFileUrl.match(chinesePattern);

                    const timestampInSeconds = Math.floor(Date.now() / 1000);
                    let chineseText = "BoSumFile" + timestampInSeconds
                    if (chineseCharacters) {
                        // 使用join方法将匹配的中文字符组合成一个字符串
                        chineseText = chineseCharacters.join('');
                    } else {
                        console.log("没有找到中文字符");
                    }
                    fetch(ossFileUrl)
                        .then(response => response.blob())
                        .then(blob => {
                            const blobUrl = window.URL.createObjectURL(blob);
                            const a = document.createElement('a');
                            a.href = blobUrl;
                            a.download = `${chineseText}.${fileType}`;
                            a.style.display = 'none';
                            document.body.appendChild(a);
                            a.click();
                            window.URL.revokeObjectURL(blobUrl);
                            resolve(`任务${taskNumber}完成`);
                        })
                        .catch(error => {
                            resolve(`任务${itemUrl},下载失败`);
                            console.error('下载失败', error);
                        });



                });
            }


            const asyncTasks = [];
            urlArr.forEach((ossFileUrl, indexA) => {
                loadingObj[index] = true
                asyncTasks.push(asyncTask(ossFileUrl, indexA,));
            })

            // 使用 Promise.all() 等待所有异步任务完成
            Promise.all(asyncTasks)
                .then((results) => {
                    loadingObj[index] = false
                })
                .catch((error) => {
                    loadingObj[index] = false
                    console.error("发生错误：", error);
                });


        }
    },
    mounted() {
        this.anchorEvent(this.$store.state.commentId)
    },
}



// WEBPACK FOOTER //
// ./src/mixins/pageMixin.js